import React from "react";
import StudioSelector from "../../components/studioSelector";
// const StudioSelector = lazy(() => import("../../components/studioSelector/index.jsx"));

const ChooserStudio = ({setVisibleStudioModal}) => {
/* <Suspense fallback={<div></div>}> */  
  return (
    <StudioSelector
      closeStudioModal={ () => {
        setVisibleStudioModal(false);
      }}
    />    
  );
};

export default ChooserStudio;
